// USA
export const locale = {
  lang: 'en',
  data: {
    TRANSLATOR: {
      SELECT: 'Select your language',
    },
    MENU: {
      STAFF: 'Staff',
      ORDERS: 'Orders',
      MANAGE: 'Manage',
      CLIENTS: 'Clients',
      PRODUCTS: 'Products',
      DASHBOARD: 'Dashboard',
      FACTORIES: 'Suppliers',
      REPORTS: 'Reports',
      SALES: 'GMV',
      HUBSPOT: 'Hubspot',
      TIMES: 'Statistics',
      RFQS: 'RFQs',
      RFQS_ORDERS: 'RFQs and Orders',
      SUBSCRIPTIONS: 'Subscriptions',
      REQUEST_FOR_QUOTES: 'Quotes',
      PENDING_ORDERS: 'Pending Orders',
      PURCHASE_ORDERS: 'Purchase Orders',
      CLIENT_PURCHASE_ORDERS: 'Client Invoices',
    },
    PAGINATOR: {
      ITEMS_PER_PAGE: 'Items per page',
      NEXT_PAGE_LABEL: 'Next',
      PREV_PAGE_LABEL: 'Previous',
    },
    AUTH: {
      GENERAL: {
        BACK_BUTTON: 'Back to Login',
        CONTACT: 'Contact',
        FORGOT_BUTTON: 'Forgot Password',
        GOOGLE_LOGIN: 'Login or Signup with Google',
        I_AGREE: 'I agree with the',
        LEGAL: 'Legal',
        NO_ACCOUNT: "Don't have an account?",
        OR: 'Or',
        PRIVACY: 'Privacy',
        SIGN_OUT: 'Sign Out',
        SIGNUP_BUTTON: 'Sign Up',
        SUBMIT_BUTTON: 'Submit',
        TERMS_CONDITIONS: 'Terms & Conditions',
      },
      LOGIN: {
        TITLE: 'Team Login',
        BUTTON: 'Sign In',
      },
      RECOVER: {
        LINK: 'Link Expired',
        NEW_PASSWORD: 'New Password',
        CREATE_NEW_PASSWORD: 'Create New Password',
        TITLE: 'Recover My Password',
        BUTTON: 'Save New Password',
      },
      FORGOT: {
        TITLE: 'Recover My Password',
        EMAIL_LABEL: 'Your login email address',
        BUTTON: 'Recover My Password',
      },
      REGISTER: {
        COMPLETE_DETAILS: 'Complete your registration using',
        DESC: 'Enter your details to create your account',
        GOOGLE_ACCOUNT: 'Google Account',
        LOGGING_IN: 'Logging In using',
        LOGIN_DETAILS_TITLE: 'Login Details',
        SUCCESS: 'Your account has been successfuly registered.',
        TITLE: 'Register New Account',
      },
    },
    GENERAL: {
      ABOUT: 'About',
      ADDRESS: 'Address',
      CHARGE: 'Charge',
      CITY: 'City',
      CONTACT: 'Contact',
      DAYS: 'Days',
      DESTINATION: 'Destination',
      EMAIL_ADDRESS: 'Email Address',
      FULLNAME: 'Full Name',
      HI: 'Hi',
      MY_PROFILE_DESC: 'Account settings and more',
      MY_PROFILE: 'My Profile',
      CHANGE_PASSWORD: 'Change Password',
      NAME: 'Name',
      NO: 'No',
      NUMBER: 'Number',
      PRICE: 'Price',
      PRODUCT: 'Product',
      QUANTITY: 'Quantity',
      SAMPLE: 'Sample',
      SHIPPING: 'Shipping',
      SIGNATURE: 'Signature',
      STATE: 'State',
      SUCCESS: 'Success',
      TEAM: 'Team',
      TOTAL: 'Total',
      YES: 'Yes',
      ZIP: 'Zip',

      GETTING_RECORDS: 'Getting records...',
      GETTING_RFQ_DETAILS: 'Getting RFQ details...',
    },
    FACTORY: {
      FACTORY_NAME: 'Factory Name',
      FACTORY_ADMIN: 'Factory Admin',
      FACTORY_DESCRIPTION: 'Factory Description',
    },
    SUPPLIER: {
      SUPPLIER_NAME: 'Supplier Name',
      SUPPLIER_ADMIN: 'Supplier Admin',
      SUPPLIER_DESCRIPTION: 'Supplier Description',
    },
    ACCOUNT: {
      BUSINESS_DETAILS_TITLE: 'Business Details',
      BUSINESS_NAME: 'Company Name',
      FEIN: 'Federal Employer Identification Number',
      BUSINESS_TYPE: 'Client Type',
      PHONE_NUMBER: 'Phone Number',
      EXTNAME: 'Ext Name',
      FIRSTNAME: 'First Name',
      LASTNAME: 'Last Name',
      MIDDLENAME: 'Middlename',
      LOGIN_EMAIL: 'Login Email',
      MEMBER_STAFF: 'Factory Staff',
      MEMBER_SALES: 'Sales Member',
      SUPPLIER_ADMIN: 'Supplier Admin',
      USER_ROLE: 'User Role',
      STATUS: 'Status',
    },
    ADDRESS: {
      STREET_ADDRESS: 'Street Address',
      BUSINESS_ADDRESS: 'Address Line 1',
      BUSINESS_ADDRESS_LINE_2: 'Address Line 2',
      CITY_ADDRESS: 'City',
      STATE_ADDRESS: 'State',
      ZIP_CODE: 'Zip',
      COUNTRY: 'Country',
    },
    CONTACT: {
      PHONE: 'Phone',
      MOBILE: 'Mobile',
    },
    FORM: {
      INPUT: {
        CONFIRM_PASSWORD: 'Confirm Password',
        EMAIL: 'Email',
        FULLNAME: 'Full Name',
        PASSWORD: 'Password',
        USERNAME: 'Username',
        LANGUAGE: 'Language',
        CURRENT_PASSWORD: 'Current Password',
        NEW_PASSWORD: 'New Password',
      },
      VALIDATION: {
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        INVALID_FIELD: 'Field is not valid',
        INVALID_LOGIN: 'The login detail is incorrect',
        INVALID: '{{name}} is not valid',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        MAX_LENGTH: '{{name}} minimum length is {{max}}',
        NOT_FOUND: 'The requested {{name}} is not found',
        REQUIRED_FIELD: 'Required field',
        REQUIRED: '{{name}} is required',
        MAX_CHARACTER_LIMIT: 'Maximum field length reached',
      },
    },
    TITLES: {
      RFQS_REPORT: 'RFQs Report',
      ORDERS_REPORT: 'Orders Report',
      SALES_REPORT: 'GMV Report',
      DATE_SENT: 'Date Sent',
      PRODUCT: 'Product',
      ASSIGNED_TO: 'Assigned To',
      CLIENT_PROFILE: 'Client Profile',
      ASSIGN_RFQ_ADMIN: 'Assign RFQ Admin',
      ASSIGN_RFQ_MEMBER: 'Assign RFQ to Staff',
      ADD_PRODUCT_VARIANT: 'Add Product Variant',
      ADD_VARIANTS: 'Add Variants',
      ANNUAL_QUANTITY: 'Qty Annual',
      ATTACH_PRODUCT_FILES: 'Attach Product Files/Pictures',
      BUSINESS_INFO: 'Business Info',
      CART_REVIEW_SIGN: 'Review and Sign Purchase Orders',
      CHANNICS_STAFF_DESC: 'Manage staff accounts and login',
      CHANNICS_STAFF: 'Staff',
      CHARGE_AMOUNT: 'Charge Amount',
      CHECKOUT_ORDERS: 'Checkout Orders',
      CLIENT_NAME: 'Client Name',
      CONFIRM_ORDER_DETAILS: 'Confirm Order Details',
      COUNTRY: 'Country',
      DATE_CREATED: 'Date Created',
      DATE_SIGNED: 'Date Signed',
      DATE_TIME_CREATED: 'Created Date/Time',
      DATE_TIME: 'Date/Time',
      DDP_AIR: 'DDP AIR',
      DDP_SEA: 'DDP SEA',
      EFFECTIVE_DATE: 'Effective Date',
      FACTORIES: 'Suppliers',
      FILE_REMARKS: 'File Remarks/Description',
      FILE: 'File',
      FILES: 'Files',
      FINAL_DESTINATION_ADDRESS: 'Final Destination Address',
      FIRST_ORDER_QUANTITY: 'Qty First Order',
      HAVE_PACKING_REQ: 'Do you have any packaging requirements?',
      IS_PRIMARY: 'Is Primary',
      LEAD_TIME: 'Lead Time',
      PRODUCTION_LEAD_TIME: 'Production Lead Time',
      MY_COMPLETED_ORDERS: 'My Completed Orders',
      MY_PENDING_ORDERS: 'My Pending Orders',
      MY_PURCHASE_ORDERS: 'My Purchase Orders',
      NEGOTIATE_PRICE: 'Negotiate Price',
      NEGOTIATED_QUOTE: 'Negotiated Quantity and Price',
      NEW_QUOTATION: 'New Quotation',
      NEW_STAFF: 'New Staff',
      EDIT_SUPPLIER: 'Update Supplier',
      NEW_SUPPLIER: 'New Supplier',
      NEW_FACTORY: 'New Factory',
      EDIT_FACTORY: 'Update Factory',
      ORDER_AMOUNT: 'Order Amount',
      ORDER_DETAILS: 'Order Details',
      ORDER_SAMPLE: 'Order Sample',
      ORDER_STATUS: 'Order Status',
      ORDER_VOLUME: 'Order Volume',
      OTHER_DETAILS: 'Other Details',
      PACKAGING_DETAILS: 'Packaging Details',
      PAYABLE_AMOUNT: 'Payable Amount',
      PAYMENT_DETAILS: 'Payment Details',
      PAYMENT_INFO: 'Payment Info',
      PAYMENT_RECEIPTS: 'Payment Receipts',
      PAYMENT_VIA: 'Payment Via',
      PENDING_PURCHASE_ORDERS: 'Pending Purchase Orders',
      PO_NUMBER: 'PO Number',
      PRODUCT_ATTACHMENTS: 'Product Attachments',
      PRODUCT_INFO: 'Product Information',
      PRODUCT_ORDER_VARIANTS: 'Product Order Variants',
      PRODUCT_VARIANTS: 'Product Variants',
      PROJECTED_DELIVERY: 'Projected Delivery',
      PURCHASE_ORDER_NUMBER: 'Purchase Order',
      PURCHASE_ORDERS: 'Purchase Orders',
      QUOTATION_FOR: 'Quotation for: ',
      QUOTATIONS: 'Quotations',
      REQUEST_FOR_QUOTES: 'Request for Quotes',
      RFQ_DETAILS: 'RFQ Details',
      SAMPLE_DETAILS: 'Sample Details',
      SAMPLE_ORDERS: 'Sample Orders',
      SKU: 'SKU',
      SHIP_PACK_DETAILS: 'Shipping and Packing Details',
      STATUS: 'Status',
      TIERED_PRICING: 'Tiered Pricing',
      TOTAL_COST: 'Total Cost',
      TOTAL_PAID: 'Total Paid',
      TOTAL_BALANCE: 'Total Balance',
      TRACKING_DETAILS: 'Tracking Details',
      UPDATE_PROFILE: 'Update Profile',
      UPDATE_PURCHASE_ORDER_STATUS: 'Update Purchase Order Status',
      UPDATE_QUOTATION: 'Update Quotation',
      UPLOAD_RECEIPT: 'Upload Receipt',
      USER_DETAILS: 'User Details',
      VARIANT_DETAIL: 'Variant Detail',
      VARIANT_NAME: 'Variant Name',
      VARIANT_TERMS_VALUES: 'Terms / Values',
      VARIANT_TERMS: 'Variant Terms',
      VIEW_ORDER_STATUS: 'View Order Status',
      VARIANT_QUOTATIONS_FOR: 'Variant Quotes for',
      NEW_VARIANT_QUOTATION: 'New Variant Quote',
      UPDATE_VARIANT_QUOTATION: 'Update Variant Quote',
      RFQ_VARIANTS: 'Rfq Variants',
      QUOTATION_NOTES: 'Quotation notes',
      VARIANTS: 'Variants',
      CLIENT_PURCHASE_ORDERS: 'Client Invoices',
      CREATE_CLIENT_PURCHASE_ORDER: 'Create Client Invoice',
      UPDATE_CLIENT_PURCHASE_ORDER: 'Update Client Invoice',
      CONFIRM_VOID_AND_REORDER_CLIENT_PURCHASE_ORDER:
        'Confirm VOID and Re-order Invoice',
    },
    LABELS: {
      PRODUCTION_LEAD_TIME: 'Production Lead Time',
      FACTORY: 'Factory',
      ANNUAL_VOLUME: 'Potential Annual Purchase Volume',
      ATTACH_PRODUCT_FILES: 'Please attach in product files',
      BUNDLING: 'Bundling',
      CAN_SEND_SAMPLE_TO_MATCH: 'Can you send us a sample to match?',
      CARTON_ARRANGE: 'Carton Arrangement',
      CHANGES_TO_MAKE: 'What changes are you wanting to make?',
      COST_PER_SAMPLE: 'Cost per Sample',
      COST_PER_UNIT: 'Cost per Unit',
      CUSTOM_PRINTING: 'Custom Printing (on boxes or bags)',
      DDP_AIR: 'DDP Air',
      DDP_SEA: 'DDP Sea',
      DEPENDS_ON_MOQ: 'Will depend on MOQ',
      DESTINATION_ADDRESS: 'Destination Address',
      DESTINATION_CITY: 'Destination City',
      DESTINATION_STATE: 'Destination State',
      DESTINATION_ZIP: 'Destination Zip',
      DEVELOPMENT_STATUS: 'How far along in development are you?',
      DONT_KNOW_YET: "Don't know yet",
      EXPIRED: 'Expired',
      EXPIRY_DATE: 'Expiry Date',
      FIRST_ORDER_QTY: 'First Order Quantity',
      HAS_INFORMATION_TO_GIVE:
        'Is there any other information you need to give us?',
      IS_ARTWORK_AVAILABLE: 'Do you have artwork availabe?',
      IS_BRAND_PRODUCT:
        'Are you wanting to brand this product? (ex. logos, tags, labels, etc.)',
      IS_NEED_CERTIFICATE:
        'Does this product need any special certificates or testing?',
      IS_NEED_GRAPHIC_DESIGN: 'Do you need Graphic design or marketing help?',
      IS_NEED_HELP_IN_PROTOTYPE:
        'Do you need help creating a mechanical drawing or prototype?',
      IS_PRODUCT_IN_MARKETPLACE:
        'Does this Product Exist in the Current Marketplace?',
      IS_SOLD_TO_AMAZON: 'Is this going to be sold on Amazon?',
      IS_WANT_PROFESSIONAL_PICTURES: 'Do you want professional product pictures?',
      LABELING: 'Labeling / Stickers',
      LOGISTICS: 'Logistics',
      MOQ_FACTORY: "we will quote the factory's MOQ",
      NOT_SURE_WITH_THIS: 'Not sure with this',
      NOT_SURE: 'Not Sure',
      ORDER_TYPE: 'Order Type',
      OTHER_DIRECTIONS: 'Other Directions',
      PER_UNIT: 'Per Unit',
      PRICE_WILL_CHANGE: 'the price will change if this changes',
      PRODUCT_CATEGORY: 'Product Category',
      PRODUCT_DESCRIPTION: 'Product Description',
      PRODUCT_HAS_VARIATION: 'This product has variations',
      PRODUCT_MARKET_LINK: 'Please provide the product link in the market',
      PRODUCT_NAME: 'Product Name',
      QUOTATION_FILES: 'Quotation Files',
      QUOTE_GENERIC: 'Quote me generic',
      QUOTE_NEG_CHECKING: 'Checking previously sent price negotiation...',
      QUOTE_NEG_COST: 'Total Cost Per Unit',
      QUOTE_NEG_DIRECTION: 'Other Directions',
      QUOTE_NEG_EXISTS: 'This has been sent last ',
      QUOTE_NEG_FACTORY_COUNTRY: 'Factory Country',
      QUOTE_NEG_UNIT_QUANTITY: 'Purchase Units Quantity',
      QUOTE_NEG_VOLUME: 'How many units will you be purchasing?',
      QUOTE_TO_US_LOCATION: 'Quote to one location in the central US by default',
      RFQ_FILES: 'RFQ Files',
      SAMPLE_LEAD_TIME: 'Sample Lead Time  (days)',
      SAMPLE_PRICE: 'Sample Price',
      TARGET_PRICE: 'Target Price',
      TELL_DETAILS: 'Tell us some details',
      TOTAL_QUANTITY: 'Total Quantity',
      UNIT_PRICE: 'Unit Price',
      UNITS: 'Units',
      VARIOUS_PREP: 'Various Prep',
      WITH_MINOR_CHANGES: 'Similar but will make minor changes',
      CLIENT_ESTIMATE: 'Estimate',
      CLIENT_PURCHASE_ORDER: 'Invoice',
      CLIENT_PURCHASE_ORDER_TYPE: 'Invoice Type',
      CLIENT_PURCHASE_ORDER_LINE_ITEMS: 'Invoice Line Items',
      CLIENT_PURCHASE_ORDER_DATE: 'Invoice Date',
      CLIENT_PURCHASE_ORDER_STATUS: 'Invoice Status',
      CLIENT_PURCHASE_ORDER_ITEMS: 'Invoice Items',
      CLIENT_PURCHASE_ORDERS: 'Invoices',
      CLIENT_PURCHASE_ORDER_ID: 'Invoice ID',
      CLIENT_PURCHASE_ORDER_FREQUENCY: 'Invoice Frequency',
      PACKAGING_SKIP: 'Packing Slip',
      RECURRING_CLIENT_PURCHASE_ORDER_PRICING: 'Recurring Invoice Pricing',
      ONLY_SHOW_MY_CLIENT_PURCHASE_ORDERS: "Only show my Client's Invoices",
      QUOTATION_LINE_ITEMS: 'Quotation Line Items',
      LOW_QTY_PRODUCT_NOTIFICATIONS_TEXT:
        'Low quantity products notfications add-on text',
      OOS_QTY_WARNING_NOTIFICATIONS_TEXT:
        'OOS quantity warning notfications add-on text',
      QUOTES_MESSAGE_NOTIFICATIONS_TEXT: 'Quotes message notfications add-on text',
      RECEIVING_REPORT_NOTIFICATIONS_TEXT:
        'Receiving report notfications add-on text',
    },
    BUTTONS: {
      ASSIGN_GO_TEAM: 'Assign Go Team',
      UPDATE_VARIANTS: 'Update Variants',
      EDIT_QUOTATION: 'Edit Quotation',
      DELETE_QUOTATION: 'Delete Quotation',
      EDIT_VARIANT_QUOTATION: 'Edit Variant Quote',
      DELETE_VARIANT_QUOTATION: 'Delete Variant Quote',
      NEW_VARIANT_QUOTATION: 'New Variant Quote',
      ASSIGN_SELECTED_RFQS: 'Assign Selected RFQs',
      SEARCH: 'Search',
      FILTER: 'Filter',
      RESET: 'Reset',
      ACCEPT_QUOTE: 'Accept Quote',
      ADD_NEW_QUOTATION: 'New Master Quote',
      ASSIGN_RFQ_ADMIN: 'Assign RFQ Admin',
      ASSIGN_RFQ_MEMBER: 'Assign RFQ to Staff',
      VIEW_CLIENT_INFO: 'View Client Info',
      ADD_QUOTATION: 'Add Quotation',
      VIEW_QUOTATION: 'View Quotation',
      ADD_NEW: 'Add New',
      ADD_TERM: 'Add Term',
      ADD_TO_CART: 'Add to Cart',
      ADD: 'Add',
      BACK: 'Back',
      CANCEL: 'Cancel',
      CLOSE: 'Close',
      CONFIRM_DELETE_TEXT: 'Yes, delete it!',
      CONFIRM_DEACTIVATE_TEXT: 'Yes, de-activate it!',
      CONFIRM_ACTIVATE_TEXT: 'Yes, activate it!',
      CONFIRM_MARK_PAID: 'Yes,  Mark as PAID!',
      CONFIRM_NEW_QUOTE_TEXT: 'Yes, request New Quote!',
      CONFIRM_ORDER: 'Confirm Order',
      CONFIRM_PAYMENT: 'Confirm Payment',
      CONFIRM_REMOVE_TEXT: 'Yes, remove it!',
      CONTINUE: 'Continue',
      CREATE_RFQ: 'Create Quote Request',
      EDIT_ORDER: 'Edit Order',
      EDIT_PRODUCT_DETAILS: 'Edit Product Details',
      EDIT_SHIPPING_ADDRESS: 'Edit Shipping Address',
      EDIT_SHIPPING_REQUIREMENTS: 'Edit Shipping Requirements',
      GO: 'Go!',
      NEGOTIATE_PRICE: 'Negotiate Price',
      NEXT: 'Next',
      OKAY: 'Okay',
      ORDER_SAMPLE: 'Order Sample',
      POST_QUOTATION: 'Post Quotation',
      RE_ORDER: 'Re-Order',
      REQUEST_QUOTE: 'Request New Quote',
      SAVE_AS_DRAFT: 'Save as Draft',
      SAVE_CHANGES: 'Save Changes',
      SAVE_UPDATES: 'Save Updates',
      SAVE: 'Save',
      SET_NEW_PASSWORD: 'Set New Password',
      SUBMIT_RFQ: 'Create New SKU',
      UPDATE_ORDER_STATUS: 'Update Order Status',
      UPDATE_PURCHASE_ORDER: 'Update Purchase Order',
      UPDATE_QUOTATION: 'Update Quotation',
      UPDATE_SAMPLE_ORDER: 'Update Sample Order',
      UPDATE: 'Update',
      UPLOAD_RECEIPT: 'Upload Receipt',
      VIEW_PRODUCT_DETAILS: 'View Product Details',
      VIEW_QUOTE: 'View Quotes',
      VIEW_RECEIPTS: 'View Receipts',
      VIEW_RFQ: 'View RFQ',
      VIEW_STATUS: 'View Status',
      VIEW: 'View',

      NEW_CLIENT_PURCHASE_ORDER: 'New Client Invoice',
      VIEW_CLIENT_PURCHASE_ORDER: 'View Invoice',
      GO_BACK_TO_CLIENT_PURCHASE_ORDERS: 'Go back to Client Invoices',
      SAVE_CLIENT_PURCHASE_ORDER: 'Save Invoice',
      CREATE_CLIENT_PURCHASE_ORDER: 'Create Client Invoice',
      UPDATE_CLIENT_PURCHASE_ORDER: 'Update Client Invoice',
      EXPORT_CLIENT_PURHASE_ORDER_TO_PDF: 'Export Invoice to PDF',
      REJECT_CLIENT_PURCHASE_ORDER: 'Reject Invoice',
      APPROVAL_CREATED_FROM_B2B_PORTAL_INVOICE: 'Approve B2b Portal Invoice',
      APPROVE_CLIENT_PURCHASE_ORDER: 'Approve Invoice',
      COMPLETE_CLIENT_PURCHASE_ORDER: 'Complete Invoice',
      SET_INVOICE_TO_ACTIVE: 'Set Invoice to Active',
      SET_INVOICE_TO_COMPLETE: 'Set Invoice to Complete',
      CANCEL_CLIENT_PURCHASE_ORDER: 'Cancel Invoice',
      CANCEL_AND_REORDER_CLIENT_PURCHASE_ORDER: 'Cancel and Re-Order Invoice',
      CONFIRM_VOID_AND_REORDER_CLIENT_PURCHASE_ORDER:
        'Confirm VOID and RE-ORDER Invoice',
      REORDER_CLIENT_PURCHASE_ORDER: 'Reorder Invoice',
      ADD_NEW_CLIENT_PURCHASE_ORDER: 'Create Invoice',
    },
    MESSAGES: {
      ATTACHMENT_REQUIRED: 'At least one file attachment is required.',
      CARD_ERROR: 'Card Error',
      CONFIRM_DELETE_QUOTE: 'Delete quotation from {{country}}?',
      CONFIRM_PO_PAYMENT:
        'Confirm payment for PO Number {{po_number}} of client {{client}}?',
      CONFIRM_QUOTE_DELETE: 'Delete quote request for {{product_name}}?',
      ORDER_COMPLETE: 'Order complete. Your order is now being processed.',
      PAYMENT_COMPLETE: 'Payment complete. Your order is now being processed.',
      PO_PAYMENT_CONFIRMED: 'Successfully confirmed and posted payment.',
      QUOTE_UPDATED: 'Quote Updated!',
      REMOVE_FROM_LIST: 'Remove {{text}} from list?',
      SENDING_REQUEST_TEXT: 'Sending request, please wait...',
      SET_CORRECT_STATUS_DATE: 'Please set correct date for status to update.',
      STRIPE_CARD_ERROR: 'stripe card error',
      VARIANT_TERM_REQUIRED: 'Please add at least 1 variant term.',

      CLICK_TO_VIEW: 'Click to view.',

      QUOTATION_VARIANT: {
        TITLE: 'RFQ Variant is required.',
        TEXT: 'Please set at least one (1) variant to proceed.',
      },
      RFQ_STAFF_ERROR: {
        TITLE: 'At least one staff required.',
        TEXT: 'Please check at least one staff to continue.',
      },
      FILE_MAX_SIZE_ERROR: {
        TITLE: 'Max file size error',
        TEXT: 'File to attach should not exceed 10MB.',
      },
      CONFIRM_DELETE_ROW: {
        TITLE: 'Delete {{name}}?',
        TEXT: 'Once deleted. This record cannot be recovered.',
      },
      CONFIRM_DEACTIVATE_ROW: {
        TITLE: 'De-Activate {{name}}?',
        TEXT: 'Login will be disabled for this account. De-activated record can be activated.',
      },
      CONFIRM_ACTIVATE_ROW: {
        TITLE: 'Activate {{name}}?',
        TEXT: 'Login will be enabled for this account.',
      },
      UPLOAD_RECEIPT_SUCCESS: {
        TITLE: 'Upload Success!',
        TEXT: 'Receipt uploaded successfully.',
      },
      LOGISTICS_REQUIRED: {
        TITLE: 'Logistics is required!',
        TEXT: "Please select this order's logistics.",
      },
      QUANTITY_ERROR: {
        TITLE: 'Quantity Error!',
        TEXT: 'Order quantity should be greater than zero(0).',
      },
      UPLOADING_RFQ_ATTACHMENT: {
        TITLE: 'Please wait...',
        TEXT: 'Saving RFQ and Uploading Attachments',
      },
      CART_SIGNED: {
        TITLE: 'Sign Success!',
        TEXT: 'Cart order signed and saved successfully.',
      },

      CART_ORDER_CREATED: {
        TITLE: 'Create Successful!',
        TEXT: 'Order added to cart.',
      },
      CART_ORDER_UPDATED: {
        TITLE: 'Update Successful!',
        TEXT: 'Cart order updated.',
      },

      QUOTE_UPDATED_NOT_AVAILABLE: {
        TITLE: 'Quotes updated or not available!',
        TEXT: 'Cannot proceed with ordering this product as the Request for Quote was updated and still awaiting for new quotes. You can re-order once new Quotes are already available.',
      },
      QUOTE_REQUEST_SENT: {
        TITLE: 'Request Sent',
        TEXT: 'You request for new quotation has been sent.',
      },
      QUOTE_EXPIRED: {
        TITLE: 'Quote Expired',
        TEXT: 'This quote is already expired. You can request a new quote for this product.',
        PRODUCT_QUOTE_EXP:
          'The quotation for this order is already expired. You can request a new quote for this product.',
      },
      UPDATE_SUCCESS: {
        TITLE: 'Update Successful!',
        TEXT: 'Record updated successfully.',
      },
      CREATE_SUCCESS: {
        TITLE: 'Created Successfully!',
        TEXT: 'Record created successfully.',
      },
      SAVE_SUCCESS: {
        TITLE: 'Save Successful!',
        TEXT: 'Record saved successfully.',
      },
      DELETE_SUCCESS: {
        TITLE: 'Delete Successful!',
        TEXT: 'Record successfully deleted.',
      },
      DEACTIVATE_SUCCESS: {
        TITLE: 'De-activation Successful!',
        TEXT: 'Account successfully deactivated.',
      },
      ACTIVATE_SUCCESS: {
        TITLE: 'Activation Successful!',
        TEXT: 'Account successfully activated.',
      },
      SERVER_TRANSACTION_ERROR: {
        TITLE: 'Transaction Error!',
        TEXT: 'An error occured while trying to save order. Please try again later or contact support.',
      },
      SERVER_SAVE_ERROR: {
        TITLE: 'Save Error!',
        TEXT: 'Error saving record. Please try again later or contact support.',
      },
      REGISTER_ERROR: {
        TITLE: 'Register Error!',
        TEXT: 'Email already in used. Please use another email address.',
      },
      REGISTER_SUCCESS: {
        TITLE: 'Accept terms and conditions!',
        TEXT: 'Please read and agree to the terms and conditions.',
      },
      ACCEPT_TERMS: {
        TITLE: 'Accept terms and conditions!',
        TEXT: 'Please read and agree to the terms and conditions.',
      },
      INVALID_LOGIN: {
        TITLE: 'Login Error!',
        TEXT: 'Invalid username or password.',
      },
      PASSWORD_RECOVERY: {
        TITLE: 'Password Recovery!',
        TEXT: 'The instruction and link to recover your password has been sent to your email.',
      },
      PASSWORD_SAVED: {
        TITLE: 'Password Saved!',
        TEXT: 'Your can now login using your new password.',
      },
      FORM_ERROR: {
        TITLE: 'Form Error!',
        TEXT: 'Please fill the all the required fields.',
      },
      CLIENT_PURCHASE_ORDER: {
        UPDATED: 'Invoice updated.',
        CREATED: 'New invoice created.',
        APPROVAL: {
          SUCCESS: 'Successfully approved invoice.',
          CONFIRM: 'This will approve the invoice and mark it as ACTIVE',
        },
        REJECT: {
          SUCCESS: 'Rejected the invoice.',
          CONFIRM: 'This will reject this invoice and mark it as DRAFT again.',
        },
        SEND_TO_CONTACTS: {
          SUCCESS: 'Successfully sent invoice to contacts',
        },
        DELETE: {
          CONFIRM: 'Delete invoice?',
          SUCCESS: 'Successfully deleted invoice.',
        },
        ROLLBACK_INVENTORY: {
          CONFIRM: 'ROLLBACK INVENTORY CHANGES FOR THIS INVOICE?',
        },
      },
      COMPANY: {
        TITLE: 'Form Error!',
        REQUIRED_FIELDS_MESSAGE: 'Please fill all the required fields.',
        COMPANY_EXIST_MESSAGE: 'Select Company that exists.',
      },
    },
    QUOTE_STATUS: {
      OUT_FOR_QUOTE: 'Out for Quote',
      QUOTE_AVAILABLE: 'Quote Available',
      QUOTES_AVAILABLE: 'Quote(s) Available',
      ORDER_PLACED: 'Order Placed',
      ORDER_CONFIRMED: 'Order Confirmed',
      SAMPLE_ORDERED: 'Sample Ordered',
      NEGOTIATED_PRICE: 'Price Negotiated',
      DRAFT: 'Draft',
      POSTED: 'Posted',
      EXPIRES_ON: 'Expires on ',
      PRICE_REQUEST: 'Price Request',
      VARIANT_QUOTES: 'View Variant Quote(s)',
    },
    ORDER_STATUS: {
      AAA: 'All Orders',
      PENDING: 'Awaiting Payment',
      ACTIVE: 'Order Placed',
      ORDER_PLACED: 'Order Placed',
      ESTIMATED_ARRIVAL: 'Estimated Time of Arrival',
      SAMPLE_SENT: 'Sample Sent',
      SAMPLE_RECEIVED: 'Sample Received',
      PRE_PRODUCTION_CONFIRMED: 'Pre-production Details Confirmed',
      PRODUCTION_STARTED: 'Production Started',
      PRODUCTION_COMPLETED: 'Production Completed',
      IN_TRANSIT: 'In Transit',
      DELIVERED: 'Delivered',
      RECEIPTS_UPLOADED: 'Receipts Uploaded',
    },
    LOGISTICS: {
      DDP_AIR: 'DDP AIR',
      DDP_SEA: 'DDP SEA',
      FOB: 'FOB',
      EXW: 'EXW',
    },
    NOTIF: {
      TITLE: 'Notifications',
      NEW_RFQ: 'submitted a new RFQ for product ',
      PRICE_NEG: 'A Price Negotition has been sent for your quote on product ',
      RFQ_ASSIGNED:
        '<i>The RFQ for product </i> <b> {{product_name}} </b> <i> has been assigned to you.</i>',
      RFQ_REQUOTE:
        '<i>A new quote has been requested for product </i> <b> {{product_name}} </b>.',
      RFQ_UPDATED:
        '<i>RFQ details have been updated for product </i> <b> {{product_name}} </b>.',
      RFQ_COMMENT:
        '<i>New comment received for product </i> <b> {{product_name}} </b>.',
      QUOTE_COMMENT:
        '<i>New comment received for the quote for product </i> <b> {{product_name}} </b>.',
      NEW_ORDER:
        '<i>New order for product </i> <b> {{product_name}} </b> <i> has been submitted by <b>{{client_name}}</b>.</i>',
      RECEIPT_UPLOADED: 'New receipt uploaded for order with po number',
      KIT_ASSIGNED:
        '<i>The KIT </i> <b> {{product_name}} </b> <i> has been assigned to you.</i>',
    },
    SETTINGS: {
      CART_ORDERS: 'Cart Orders',
      CART_ORDERS_MAX_AGE_DAYS: 'Max age in days',
      SAVE_SETTINGS: 'Save Settings',
      TITLE: 'System Settings',
      LABEL: 'Terms Detail',
      LABEL_MARKUP: 'Markup Detail',
      MIN_ORDER: 'Min Order',
      MAX_ORDER: 'Max Order',
      DOWNPAYMENT: 'Downpayment',
      FINAL_PAYMENT: 'Final Payment',
      MARKUP: 'Markup',
      PAYMENT_TERMS: 'Payment Terms',
      MARK_UP_STRUCTURE: 'Markup Structure',
      LEAD_TIMES: 'Default Lead Times',
      SHIPPING_SEA: 'Shipping Lead Time by Sea',
      SHIPPING_AIR: 'Shipping Lead Time by Air',
      SHIPPING_FOB: 'Lead Time by FOB',
      SHIPPING_CIF: 'Lead Time by CIF',
      MESSAGE_SAVE: {
        TITLE: 'Save Success',
        TEXT: 'System settings saved successfully.',
      },
    },
    TEXT: {
      VARIANT_QUOTE_TYPE_ALL_DIFFERENT: 'All variants have different pricing',
      VARIANT_QUOTE_TYPE_ALL_SAME: 'All variants have the same pricing',
      VARIANT_QUOTE_TYPE_SOME_DIFFERENT: 'Some variants have different pricing',
      CHECKOUT_NO_PRODUCT:
        'No products signed for checkout. Please sign your products first then checkout and pay.',
      CONFIRM_ORDER_DETAILS:
        'Here are the order details you have entered. Continue if these are correct or edit to update some details.',
      CONFIRM_PRODUCT_DETAILS:
        'Here is all of the product information you inputted in your RFQ, are all of these variations correct? If there are any size or color variations have you provided ample detailed information to the factory here (i.e. pantone colors, drawings, dimensions, etc.)? If not, please edit now or click continue.',
      CONFIRM_SHIPPING_ADDRESS:
        'Here is the shipping address you provide us, is this correct? Do you need to change the address? Do you have more than one shipping address? If yes, then edit now, or confirm this order to proceed.',
      CONFIRM_SHIPPING_REQUIREMENTS:
        'Here are the shipping details you originally put down, are you sure these are your final shipping requirements? If not, please edit now or click continue',
      ENTER_NAME: '(Enter your name)',
      QUOTE_NEG_TITLE:
        'Please give us your target cost per unit and we will work on getting a better price.',
      REVIEW_SIGN_TEXT:
        'I have reviewed the above information and have verified that it is correct. I authorize Yama to create a Purchase Order.',
      REVIEW_VERIFY_TEXT:
        'I have reviewed all the information and verified that it is correct. I authorized Yama to create a Purchase Order.',
      TOTAL_ORDER_AMOUNT: 'Total Order Amount',
      TOTAL_PAYABLE_AMOUNT: 'Total Payable Amount',
      WIRE_PAYMENT_DESC:
        'An email will be sent to you containing detailed instructions on how to pay this purchase order via Wire Transfer together with the PO number.',
      WIRE_PAYMENT: 'Payment via Wire Transfer',

      OD_SAMPLE_TO_WATCH: 'With sample to match',
      OD_SOLD_TO_AMAZON: 'Will be sold on Amazon',
      OD_HELP_IN_MECHANICAL_PROTOTYPE:
        'Needs help creating mechanical drawing or prototype',
      OD_HELP_IN_GRAPHIC_DESIGN: 'Needs graphic design or marketing help',
      OD_NEED_CERTIFICATES: 'Product needs special certificates or testing',
      OD_WANT_PROFESSIONAL_PICTURES: 'Wants professional product pictures',

      SR_LABELING: 'Labeling / Stickers',
      SR_PRINTING: 'Custom Printing (on boxes or bags)',
      SR_BUNDLING: 'Bundling',
      SR_VARIOUS_PREP: 'Various Prep',
      SR_CARTON: 'Carton Arrangement',
      SR_GENERIC: 'Quote me Generic',

      PD_PRODUCT_ON_MARKET: 'Does product exist on marketplace',
      PD_DEVELOPMENT_STATUS: 'Development Status',
      PD_PRODUCT_LINK: 'Product Link',
      PD_PRODUCT_LISTINGS: 'Product Listings',
      PD_CHANGES_TO_MAKE: 'Changes to make',
      PD_MINOR_CHANGES: 'Similar but will make minor changes',
      PD_BRAND_PRODUCT: 'Want to brand this product (logos, tags, labels, etc)',
      PD_ART_AVAILABLE: 'Art available as attached',

      CONFIRM_ORDER:
        'Because you have changed the original details of the quote, we will have to reconfirm with the factory and update the quote. You can create your order again once the quotes are updated and available.',
      SEARCH_FOR_PRODUCT: 'Search for product...',

      EDIT_RECORD: 'Edit Record',
      DELETE_RECORD: 'Delete Record',

      SELECT_PRODUCT: 'Select product',
    },

    RFQ: {
      QUOTE_TYPE_TITLE: 'Request for Quote Type',
      QUICK_QUOTE: 'Quick Quote',
      PRODUCT_RECOMMENDATION: 'Product Recommendation',
      EXACT_QUOTE: 'Exact Quote',
      DETAILS: 'Details',
      QUOTATIONS: 'Quotations',
      MESSAGES: 'Messages',
    },

    PRODUCTS: {
      TITLE: 'Channics Sourcing Products',
      PRODUCT_NAME: 'Product Name',
      PRODUCT_CATEGORY: 'Product Category',
      PRODUCT_VARIANTS: 'Product Variants',
      PRODUCT_DESCRIPTION: 'Product Description',
      PRODUCT_PHOTOS: 'Photos',
      PRODUCT_DETAILS: 'Product Details',
      PRODUCT_FILES: 'Photos and Files',
      TIERED_PRICING: 'Tiered Pricing',
      PRODUCT_SPECIFICATIONS: 'Specifications',
      SAVE_AND_NEXT: 'Save and Next',
      SAMPLE_LEAD_TIME: 'Sample Lead Time',
      SAMPLE_PRICE: 'Sample Price',
      SAMPLE_MIN_ORDER: 'Sample Min Order',
      SPECIFICATION: 'Specification',
      TAGS: 'Tags',
      LABEL: 'Label',
      VALUE: 'Value',
      IMAGES: 'Images',
      FILES: 'Files',
      ADD_VARIANT: 'Add Variant',
      VARIANT_NAME: 'Variant Name',
      VARIANT_TERM: 'Variant Term',
      VARIANT_VALUE: 'Variant Value',
      VARIANT_IMAGE: 'Variant Photo',
      UPDATE_PRODUCT: 'Update Product',
      BASE_TIERED_PRICE: 'Base Tiered Pricing',
      VARIANT_TIERED_PRICE: 'Variant Tiered Pricing',
      ADD_VARIANT_PRICE: 'Add Variant Price',
      FINISHED: 'Finished',
    },
    CLIENTS: {
      BILLING_DETAILS: 'Billing Details',
      UPDATE_PROFILE: 'Update Profile',
      TITLES: 'Source Channics Clients',
      INVOICES: 'Invoices',
      TITLE_DESC: "Manage clients' records",
      BUSINESS_NAME: 'Business Name',
      USER_ACCOUNT: 'Contact Name',
      BUSINESS_TYPE: 'Business Type',
      BUSINESS_ADDRESS: 'Business Address',
      CITY: 'City',
      STATE: 'State',
      ZIP: 'Zip',
      PHONE: 'Phone',
      QUOTATION_REQUESTS: 'Quotation Requests',
      PENDING_ORDERS: 'Pending Orders',
      ACTIVE_ORDERS: 'Active Orders',
      PURCHASE_ORDERS: 'Purchase Orders',
      PROFILE: 'Profile',
      BUSINESS_DETAILS: 'Business Details',
      ACCOUNT_INFO: 'Account Info',
      PENDING_RFQS: 'Pending RFQs',
      SHIPPING_DETAILS: 'Shipping Details',
      SHIPPING_ADDRESS: 'Address Line 1',
      SHIPPING_ADDRESS_LINE_2: 'Address Line 2',
      SHIPPING_CITY: 'City',
      SHIPPING_STATE: 'State',
      SHIPPING_ZIP: 'Zip',
      SHIPPING_COUNTRY: 'Country',
      SET_NEW_PASSWORD: 'Set New Password',
      ACCOUNT_NUMBER: 'Account Number',
      COMPANY_CONTACT_FIRSTNAME: 'First Name',
      COMPANY_CONTACT_LASTNAME: 'Last Name',
      COMPANY_CONTACT_PHONE: 'Phone Number',
      COMPANY_CONTACT_EMAIL: 'Email',
      SHIPPING_TYPE: 'Shipping Type',
      NOTES: 'Notes',
    },

    MESSAGING: {
      POST_COMMENT: 'Post Comment',
      CLIENT_MESSAGES: 'Client Messages',
    },
    BILLED_USER: {
      FIRST_NAME: 'First Name',
      LAST_NAME: 'Last Name',
      EMAIL: 'Email Address',
      COMPANY_NAME: 'Company Name',
      BUSINESS_ADDRESS: 'Business Address',
      PHONE: 'Phone',
      NO_DEFAULT_BILLED_USER: 'There is no default billed user.',
      LOADING: 'Loading...',
      RECEIVING_BANK_NAME: 'Receiving Bank Name',
      RECEIVING_BANK_ADDRESS: 'Receiving Bank Address',
    },
    SALES: {
      SPLIT_ORDERS: 'Split Orders',
      LINE_ITEMS: 'Line Items',
      LUMINOUS_SKUS: 'Luminous SKUs',
      POSTED_ORDERS: 'Allocated Orders',
      ORDER_STATUS: 'Order Status',
      CHANNEL: 'Channel',
      SKUS_OR_KITS: 'SKUs / Kits',
    },
  },
};
